export const favoriteFilterKeys = {
	trackerIds: 'favAdmFRTrackerIds',
	creativeIds: 'favAdmFRCreativeIds',
	brands: 'favAdmFRBrands',
	currencies: 'favAdmFRCurrencies',
	dealTypes: 'favAdmFRDealTypes',
	productIds: 'favAdmFRProductIds',
	platformIds: 'favAdmFRPlatformIds',
	playerId: 'favAdmFRPlayerId',
	anid: 'favAdmFRAnid',
  source1: 'favAdmFRSource1',
  source2: 'favAdmFRSource2',
  source3: 'favAdmFRSource3',
  source4: 'favAdmFRSource4',
  source5: 'favAdmFRSource5',
	deviceTypes: 'favAdmFRDeviceTypes',
	managerIds: 'favAdmFRManagerIds',
	affiliateIds: 'favAdmFRAffiliateIds',
	costOptimizations: 'favAdmFRCostOptimizations',
	registrationDates: 'favAdmFRRegDates',
	firstDepositDates: 'favAdmFRFirstDepDates',
	geo: 'favAdmFRGeo',
	trafficSources: 'favAdmFRTrafficSources',
}

export const reportStorageProps = {
  type: 'full-report',
  target: 'filters',
  tableSettingsTarget: 'table-settings',
  savedReportTarget: 'full-report-settings',
  savedReportFavoritesTarget: 'full-report-favorites',
  savedReportDefaultTarget: 'full-report-default',
  exceptions: ['group_by', 'period', 'sent_from', 'sent_to'],
  exceptionsIds: ['productIds', 'platformIds', 'managerIds', 'affiliateIds', 'trackerIds', 'brands', 'currencies', 'dealTypes', 'deviceTypes', 'trafficSources'],
  exceptionsStr: ['anid', 'playerId', 'source1', 'source2', 'source3', 'source4', 'source5'],
  maxFavoriteReports: 10,
}
